import { Link } from "react-router-dom";
import { BRAND, waLink, WA_MSG } from "../data/content";
import { Reveal } from "./shared";
import { WhatsAppIcon } from "./Navbar";
import { Instagram } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/services", label: "Services" },
  { to: "/venues", label: "Venues" },
  { to: "/gallery", label: "Gallery" },
  { to: "/wedding-ideas", label: "Wedding Ideas" },
  { to: "/testimonials", label: "Testimonials" },
  { to: "/enquire", label: "Enquire" },
  { to: "/contact", label: "Contact Us" },
];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-emerald-deep text-ivory" data-testid="footer">
      <div className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full border border-gold/15" />
      <div className="pointer-events-none absolute -left-32 bottom-0 h-[28rem] w-[28rem] rounded-full border border-gold/10" />
      <div className="relative mx-auto max-w-7xl px-6 py-20 md:px-12 md:py-24">
        <div className="grid gap-14 md:grid-cols-12">
          <div className="md:col-span-5">
            <Reveal>
              <img src="/logo.jpg" alt="The Big Wedd emblem" data-testid="footer-logo" className="h-16 w-16 rounded-full object-cover ring-1 ring-gold/40" />
              <p className="mt-5 font-serif text-4xl md:text-5xl leading-tight">
                THE BIG <span className="italic text-gold">WEDD</span>
              </p>
              <p className="mt-3 text-xs uppercase tracking-[0.3em] text-gold-light/80">{BRAND.tagline}</p>
              <p className="mt-6 max-w-sm text-sm leading-relaxed text-ivory/60">
                Creating celebrations that become your favourite memories — across India and abroad.
              </p>
              <div className="mt-8 flex items-center gap-4 text-xs uppercase tracking-[0.25em] text-ivory/70">
                {BRAND.locations.map((l, i) => (
                  <span key={l} className="flex items-center gap-4">
                    {l} {i < BRAND.locations.length - 1 && <span className="h-1 w-1 rotate-45 bg-gold/70" />}
                  </span>
                ))}
              </div>
            </Reveal>
          </div>
          <div className="md:col-span-3">
            <Reveal delay={0.1}>
              <p className="text-[11px] uppercase tracking-[0.3em] text-gold">Quick Links</p>
              <ul className="mt-6 space-y-3">
                {LINKS.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm text-ivory/70 transition-colors hover:text-gold-light">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
          <div className="md:col-span-4">
            <Reveal delay={0.2}>
              <p className="text-[11px] uppercase tracking-[0.3em] text-gold">Start The Conversation</p>
              <p className="mt-6 text-sm text-ivory/60 leading-relaxed">Tell us your vision, your destination and your dream wedding.</p>
              <Link to="/enquire" data-testid="footer-cta-plan-my-wedding" className="mt-6 inline-flex rounded-full bg-gold px-8 py-4 text-[11px] font-medium uppercase tracking-[0.22em] text-ink transition-all duration-500 hover:-translate-y-0.5 hover:bg-ivory">
                Plan My Wedding
              </Link>
              <div className="mt-8 flex items-center gap-4">
                <a href={BRAND.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 text-gold-light transition-all hover:bg-gold hover:text-ink">
                  <Instagram className="h-4 w-4" />
                </a>
                <a href={waLink(WA_MSG)} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" aria-label="WhatsApp" className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 text-gold-light transition-all hover:bg-gold hover:text-ink">
                  <WhatsAppIcon className="h-4 w-4" />
                </a>
                <a href={`mailto:${BRAND.email}`} data-testid="footer-email" className="text-sm text-ivory/70 hover:text-gold-light">{BRAND.email}</a>
              </div>
            </Reveal>
          </div>
        </div>
        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-gold/15 pt-8 text-[11px] uppercase tracking-[0.2em] text-ivory/40 md:flex-row">
          <p>© {new Date().getFullYear()} The Big Wedd. All rights reserved.</p>
          <p>Weddings · Celebrations · Destinations</p>
        </div>
      </div>
    </footer>
  );
}
